import CandidateEducationItem, {
  CandidateEducationItemComponentProps,
} from './CandidateEducationItem.component';
import ProfileInfoPreview, { ProfileInfoPreviewType } from '../ProfileInfoPreview';

export type CandidateEducationItemProps = Pick<ProfileInfoPreviewType, 'onEditInfo' | 'onDelete'> &
  CandidateEducationItemComponentProps;

const CandidateEducationItemContainer = ({
  isEditing,
  ...props
}: CandidateEducationItemProps): JSX.Element => {
  const { university, degree, endMonth, endYear, startMonth, startYear, onEditInfo, onDelete } =
    props;

  return isEditing ? (
    <CandidateEducationItem {...props} isEditing={isEditing} />
  ) : (
    <ProfileInfoPreview
      onDelete={onDelete}
      title={university}
      subtitle={degree}
      detail=""
      onEditInfo={onEditInfo}
      fromMonth={startMonth}
      fromYear={startYear}
      toMonth={endMonth}
      toYear={endYear}
      datePeriodLabel="Currently pursuing"
    />
  );
};

export default CandidateEducationItemContainer;
